function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.912)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M38.245,89.535H21.288l-3.373-4.009a.576.576,0,0,0-.461-.207H3.774A3.8,3.8,0,0,0,0,89.12v24.657a3.8,3.8,0,0,0,3.8,3.8H38.245a3.8,3.8,0,0,0,3.8-3.8V93.332A3.8,3.8,0,0,0,38.245,89.535Z",
  transform: "translate(0 -85.319)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M81.627,46.9H64.665l-3.373-4.009a.576.576,0,0,0-.461-.207H47.155A3.8,3.8,0,0,0,43.4,45.96H55.873a2.207,2.207,0,0,1,1.7.788l2.88,3.424h16.2A5.437,5.437,0,0,1,82.074,55.6V74.9A3.8,3.8,0,0,0,85.4,71.132V50.687A3.8,3.8,0,0,0,81.627,46.9Z",
  transform: "translate(-43.4 -42.679)"
}));

const SvgIconHistoriasClinicas = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37.167,
    viewBox: "0 0 47 37.167",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHistoriasClinicas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Historias_Clinicas.9bfdc5c6.svg";
export { ForwardRef as ReactComponent };